import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
export const InvitedGuestResponse = z.object({ id: z.string() });
export const InvitedGuestsArrayResponse = z.array(InvitedGuestResponse);
export class InvitedGuestResponseDto extends createZodDto(InvitedGuestResponse) {
}
